import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import es from "vee-validate/dist/locale/es.json";
import { calculateDistanceBetweenColumns } from "@/utils/getDistanceBetweenWords";

export default {
  install(Vue) {
    Vue.component("ValidationProvider", ValidationProvider);
    Vue.component("ValidationObserver", ValidationObserver);

    Object.keys(rules).forEach((rule) => {
      extend(rule, rules[rule]);
    });

    extend("hasEmailDuplicated", {
      params: ["customers", "currentIndex"],
      validate(email, { customers, currentIndex }) {
        return (
          customers
            .filter((_, index) => index != currentIndex)
            .filter((c) => c.email == email).length === 0
        );
      },
      message: () => {
        return "El email se encuentra duplicado en otro cliente";
      },
    });

    extend("hasPhoneDuplicated", {
      params: ["customers", "currentIndex"],
      validate(phone, { customers, currentIndex }) {
        return (
          customers
            .filter((_, index) => index != currentIndex)
            .filter((c) => c.phone == phone).length === 0
        );
      },
      message: () => {
        return "El celular se encuentra duplicado en otro cliente";
      },
    });

    extend("hasIdentificationDuplicated", {
      params: ["customers", "currentIndex"],
      validate(identificationNumber, { customers, currentIndex }) {
        return (
          customers
            .filter((_, index) => index != currentIndex)
            .filter((c) => c.identificationNumber == identificationNumber)
            .length === 0
        );
      },
      message: () => {
        return "La identificación se encuentra duplicada en otro cliente";
      },
    });

    extend("invalidPhoneNumber", {
      validate(phone) {
        let phoneRegex = /^\+\d{12}$/;
        return phoneRegex.test(phone);
      },
      message: () => {
        return "Ingrese un número de teléfono válido en el formato: +573004003020.";
      },
    });

    extend("excelColumnRange", {
      params: ["columnStart", "columnEnd"],
      validate(value, { columnStart, columnEnd }) {
        if (!columnStart || !columnEnd) {
          return true;
        }
        const distance = calculateDistanceBetweenColumns(
          columnStart,
          columnEnd
        );
        return distance > 0;
      },
      message: "Rango incorrecto",
    });

    localize("es", es);
  },
};
